import React, { useState, useEffect } from 'react';
import { createGIF } from 'gifshot';

// The booth already renders the Vejthani frame into each gif image, so these are
// stitched together as-is - nothing extra is drawn on top.
const GIFCreator = ({ userData, setPageGifUrl }) => {
  const [gifUrl, setGifUrl] = useState('');
  const [progress, setProgress] = useState(0);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    // Frames hold a different number of photos, so take every gifN that exists
    // (gif0, gif1, gif2, ...) and stop at the first gap. Duplicating a frame to
    // pad the list would make that photo linger twice as long in the loop.
    const images = [];
    for (let i = 0; userData[`gif${i}`]; i++) images.push(userData[`gif${i}`]);

    if (images.length === 0) {
      setFailed(true);
      return;
    }

    createGIF(
      {
        images,
        gifWidth: 1000,      // matches the booth's gif capture size
        gifHeight: 1350,
        numWorkers: 5,
        numFrames: 20,
        numColors: 256,
        frameDuration: 5,
        sampleInterval: 1,
        progressCallback: e => setProgress(parseInt(e * 100)),
      },
      obj => {
        if (obj.error) {
          console.error('GIF creation failed:', obj.error);
          setFailed(true);
          return;
        }
        setGifUrl(obj.image);
        setPageGifUrl(obj.image);
        setProgress(0);
      }
    );
  }, [userData, setPageGifUrl]);

  if (failed) {
    return <p className="statusText">GIF unavailable</p>;
  }

  return gifUrl
    ? <img className="gifImage" src={gifUrl} alt="Your photobooth GIF" />
    : <p className="statusText">Loading GIF... {progress}%</p>;
}

export default GIFCreator;
